import { post,get } from '@/utils/request'

export const getAudit = (p) => post('/tradeCommodity/audit', p) //审核信息
export const getInfo = (p) => get('/tradeCommodity/details', p) //详情信息
export const cancelAudit = (p) => post('/tradeCommodity/cancelAudit', p) //取消审核